/**
 * @component {"type":"sortToGroups","version":"1.0"}
 */
define('task-sort-to-groups',['knockout', 'helpers', 'utils', 'dragula', 'user-answers', 'layout-mobile'], function(ko, helpers, utils, dragula, UserAnswers, LayoutMobile) {
    'use strict';

    return function(parentVM, dataContext, taskVM) {
        var self = this,
            entityVM = parentVM.entity,
            layoutVM = parentVM.layout,
            trainingVM = parentVM.training;

        if (!dataContext.learning || !dataContext.learning.current) {
            return;
        }

        self.single = ko.observable(false);

        var getNode = function(target, str) {
            if (target && target.classList && target.classList.contains(str)) {
                return target;
            }

            if (!target.parentNode) {
                return null;
            }

            return getNode(target.parentNode, str);
        };

        var drake,
            cssClass = 'f-row-sort-checked',
            hidden = false,
            single = false,
            isSingle = false,
            removeNode = function(e) {
                var node = getNode(e.target, 'js-sort-remove'),
                    ID = (node) ? node.dataset.id : '';

                e.preventDefault();

                if (!ID) {
                    return;
                }

                var answer = document.getElementById(ID),
                    container = document.getElementById('drop-container');

                if (!answer || !container) {
                    return;
                }

                answer.classList.add('f-row-active');

                var child = container.querySelector('.js-sort-answer:first-child');

                if (child) {
                    container.insertBefore(answer, child);
                } else {
                    container.appendChild(answer);
                }

                trainingVM.validate();

                e.stopImmediatePropagation();
            },
            checkNode = function(e) {
                var node = getNode(e.target, 'js-sort-answer'),
                    parent = (node) ? node.parentNode : {};

                e.preventDefault();

                if (!node || parent.id !== 'drop-container') {
                    return;
                }

                if (node.classList.contains(cssClass)) {
                    node.classList.remove(cssClass);
                } else {
                    var checked = document.querySelector('.' + cssClass);

                    if (checked) {
                        checked.classList.remove(cssClass);
                    }

                    node.classList.add(cssClass);
                }

                e.stopImmediatePropagation();
            },
            dropNode = function(e) {
                var node = getNode(e.target, 'js-drop-cat'),
                    ID = (node) ? node.dataset.id : '',
                    answer,
                    checked,
                    container;

                e.preventDefault();

                if (!ID) {
                    return;
                }

                if (isSingle) {
                    answer = document.querySelector('.f-row-sort:first-child');
                    checked = document.querySelector('.' + cssClass);
                } else {
                    answer = document.querySelector('.' + cssClass);
                }

                answer = (isSingle) ? document.querySelector('.f-row-sort:first-child') : document.querySelector('.' + cssClass);
                container = document.getElementById(ID);

                if (!answer || !container) {
                    return;
                }

                answer.classList.remove(cssClass);
                answer.classList.remove('f-row-active');

                if (checked) {
                    checked.classList.remove(cssClass);
                }

                container.appendChild(answer);

                trainingVM.validate();

                if (trainingVM.isValid() && hidden) {
                    trainingVM.submitForm();
                }

                e.stopImmediatePropagation();
            },
            initiate = function() {
                var i = 0,
                    cats = document.querySelectorAll('.js-drop-cat'),
                    removes = document.querySelectorAll('.js-sort-remove'),
                    containers = document.querySelectorAll('.js-drop-container');

                for (i = 0; i < cats.length; i++) {
                    cats[i].addEventListener('touchend', dropNode, false);
                    cats[i].addEventListener('click', dropNode, false);
                }

                if (!single) {
                    var labels = document.querySelectorAll('.js-sort-label');

                    for (i = 0; i < labels.length; i++) {
                        labels[i].addEventListener('touchend', checkNode, false);
                        labels[i].addEventListener('click', checkNode, false);
                    }
                }

                for (i = 0; i < removes.length; i++) {
                    removes[i].addEventListener('touchend', removeNode, false);
                    removes[i].addEventListener('click', removeNode, false);
                }

                if (drake) {
                    drake.destroy();
                    drake = null;
                }

                drake = dragula({
                    invalid: function (el) {
                        var isInvalid = function(node) {
                            if (!node) {
                                return true;
                            }

                            if (node.id === 'drop-container') {
                                return false;
                            }

                            if (!node.parentNode) {
                                return true;
                            } else {
                                return isInvalid(node.parentNode);
                            }
                        };

                        return isInvalid(el.parentNode);
                    }
                });

                for (i = 0; i < containers.length; i++) {
                    drake.containers.push(containers[i]);
                }

                drake.on('drop', function(answer) {
                    if (dataContext.mobile.enabled && !layoutVM.isFixed()) {
                        var layoutMobile = new LayoutMobile();
                        layoutMobile.update();
                    }

                    answer.classList.remove(cssClass);
                    answer.classList.remove('f-row-active');

                    trainingVM.validate();

                    if (trainingVM.isValid() && hidden) {
                        trainingVM.submitForm();
                    }
                });
            };

        self.computedQuestions = ko.computed(function() {
            var entityContent = entityVM.entityContent(),
                res = [],
                userAnswer,
                userAnswers = new UserAnswers(),
                computedQuestions = trainingVM.computedQuestions(),
                parseUserAnswers = function(ID, answers) {
                    var res = [],
                        getLabel = function(ID, arr) {
                            arr = arr || [];

                            for (var i = 0; i < arr.length; i++) {
                                if (arr[i].id === ID) {
                                    return arr[i].text;
                                }
                            }

                            return '';
                        },
                        computedAnswers = trainingVM.computedAnswers();

                    answers.forEach(function(answer) {
                        if (answer.questionId === ID) {
                            res.push({
                                id: answer.answerId,
                                questionId: answer.questionId,
                                text: getLabel(answer.answerId, computedAnswers),
                            });
                        }
                    });

                    return res;
                };

            if (taskVM.isEnabled()) {

                computedQuestions.forEach(function(computedQuestion) {
                    res.push({
                        id: computedQuestion.id,
                        text: computedQuestion.text
                    })
                });

            } else {
                userAnswer = userAnswers.getUserAnswer(entityContent.ID);

                if (!userAnswer.answers) {
                    return res;
                }

                computedQuestions.forEach(function(computedQuestion) {
                    res.push({
                        id: computedQuestion.id,
                        text: computedQuestion.text,
                        userAnswers: parseUserAnswers(computedQuestion.id, userAnswer.answers)
                    })
                });
            }

            return res;
        }).extend({deferred: true});


        var timeoutID;

        ko.bindingHandlers.taskSortToGroups = {
            update: function(container, valueAccessor) {
                var content = helpers.component.getContent(entityVM.componentsJSON(), 'sortToGroups'),
                    removeEventListeners = function() {
                        window.removeEventListener('resize', resizeLayout);
                    };

                ko.unwrap(valueAccessor());

                function resizeLayout() {
                    if (timeoutID) {
                        clearTimeout(timeoutID);
                    }

                    timeoutID = setTimeout(function() {
                        isSingle = (utils.getLayout() === 'js-cols') ? false : true;
                    }, 150);
                }

                if (trainingVM.answersEnabled()) {

                    hidden = (content.submit === false) ? true : false;
                    single = (content.single) ? content.single : false;

                    isSingle = (utils.getLayout() === 'js-cols') ? single : true;

                    self.single(single)

                    setTimeout(function() {
                        initiate();
                    }, 150);
                }

                ko.utils.domNodeDisposal.addDisposeCallback(container, removeEventListeners);

                if (!single) {
                    window.addEventListener('resize', resizeLayout);
                }

            }
        };
    }

});

